import React from "react";

export type EmailMessageProps = {
  recipient: string;
  subject: string;
  children: React.ReactNode;
};

/** Shared email typography for workflow previews and editable email templates. */
export function EmailMessage({ recipient, subject, children }: EmailMessageProps) {
  return (
    <div className="tw-boundary">
      <div className="break-words text-[18px] leading-[27px] text-neutral-900">
        <p className="m-0 font-bold">To: {recipient}</p>
        <p className="mb-0 mt-[16px] font-bold">Subject: {subject}</p>
        <div className="mt-[16px] [&_p]:mt-0 [&_p]:mb-[18px] [&_p:last-child]:mb-0 [&_ul]:my-[18px] [&_ul]:pl-[24px] [&_ul]:list-disc [&_ol]:my-[18px] [&_ol]:pl-[24px] [&_ol]:list-decimal [&_a]:text-primary-600 [&_a]:underline">
          {children}
        </div>
      </div>
    </div>
  );
}
